const general = {
  name: "Remade Market",
};

export default general;
